export default __webpack_public_path__ + "static/ee3646130ada97549f759caf36f48c95.png";